import React from "react";
import img from "../../../../Assets/SlideCocina.png";
import style from "./sliderCocina.module.css";

export const CoWorking = () => {
  return (
    <div className={style.container}>
      <div className={style.item1}>
        <div className={style.textCont}>
          <h3 className={style.title}> CoWorking</h3>
          <span className={style.text}>
          Contamos con el espacio ideal, equipado a tus necesidades, para que puedas disfrutar de tu hora de almuerzo.          </span>
        </div>
      </div>

      <img src={img} alt="" className={style.img} />
    </div>
  );
};
